<template>
  <div>
    <transition name="fade" mode>
      <!-- Add more card -->
      <div class="card">
        <div class="card-body card-body-added">
          <h6>Legg til overvåket fjellskredobjekt</h6>
          <div>
            <fieldset class="boxes">
              <input
                type="checkbox"
                v-model="allRockslideObjectsSelected"
                id="allRockslideObjectsSelect"
                @change="allRockslideObjectsChanged"
              />
              <label for="allRockslideObjectsSelect" class="input-label">
                <span>Alle objekter</span>
              </label>
            </fieldset>
            <fieldset class="boxes boxes-single">
              <div
                v-for="rockslideObject in visibleRockslideObjects"
                :key="rockslideObject.name"
              >
                <label class="input-label" :for="rockslideObject.name">
                  <input
                    type="checkbox"
                    :id="rockslideObject.name"
                    :value="rockslideObject"
                    v-model="selectedRockslideObjects"
                    @change="selectedRockslideObjectsChanged"
                  />
                  <div class="object-label">
                    <span class="">
                      {{ rockslideObject.name }} </span
                    ><br />
                    <span class="card-text">
                      Fjellparti i {{ rockslideObject.kommunenavn }} kommune,
                      {{ rockslideObject.fylkesnavn }}
                    </span>
                  </div>
                </label>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import TypeService from "../store/TypeService.js";

export default {
  name: "RockslideObjectSelector",
  props: {
    existingSubscription: {},
    subscriptionType: {},
    regions: [],
  },
  data() {
    return {
      TypeService: TypeService,
      selectedRockslideObjects: [],
      allRockslideObjectsSelected: false,
    };
  },
  computed: {
    visibleRockslideObjects() {
      return this.$store.getters.rockslideObjects;
    },
  },
  created() {
    this.reset();
  },
  methods: {
    reset() {
      if (this.existingSubscription) {
        if (
          this.existingSubscription.rockslideObjects &&
          this.existingSubscription.rockslideObjects.length > 0
        ) {
          const rockslideObjects = this.$store.getters.rockslideObjects
          for (
            let i = 0;
            i < rockslideObjects.length;
            i += 1
          ) {
            const ro = rockslideObjects[i];
            if (
              this.existingSubscription.rockslideObjects.indexOf(ro.name) > -1
            ) {
              this.selectedRockslideObjects.push(ro);
            }
          }
        }
        if(this.selectedRockslideObjects.length === this.visibleRockslideObjects.length)
        {
          this.allRockslideObjectsSelected = true;
        }
      }
    },
    allRockslideObjectsChanged() {
      if (this.allRockslideObjectsSelected) {
        this.selectedRockslideObjects = this.visibleRockslideObjects;
      } else {
        this.selectedRockslideObjects = [];
      }
      this.emitSelectedAndAddedRockslideObjects();
    },
    selectedRockslideObjectsChanged() {
      this.allRockslideObjectsSelected =
        this.visibleRockslideObjects.length ===
        this.selectedRockslideObjects.length;
      this.emitSelectedAndAddedRockslideObjects();
    },
    emitSelectedAndAddedRockslideObjects() {
      this.$emit("norwaySelected", false);
      this.$emit(
        "regionAdded",
        [].concat(this.selectedRockslideObjects)
      );
    },
    clearRockslideObjects() {
      this.selectedRockslideObjects = [];
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.card-body {
  background-color: rgba(4, 73, 98, 0.035);
}

.region-select {
  height: 36px;
  border: 1px solid #979797;
  border-radius: 2px;
  font-size: 16px;
  line-height: 140%;
  color: #444444;
  width: 80%;
  margin-bottom: 16px;

  padding-left: 8px;
  cursor: pointer;
}

option.one-bold:nth-child(2) {
  font-weight: bold;
}
option.two-bold:nth-child(2) {
  font-weight: bold;
}
option.two-bold:nth-child(3) {
  font-weight: bold;
}

.wrapper {
  margin: 0;
  padding: 0;
}

.object-label {
  float: right;
  margin-bottom: 8px;
}

.clear {
  clear: both;
}

.boxes-single ul li {
  display: block !important;
  width: 100%;
}
</style>
